// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__2Pe-3","question":"Question_question__13PoP","description":"Question_description__3cel4"};